import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClass: 'kt-menu__link-icon flaticon2-graphic',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                // { name: 'Layouts', route: 'layouts' },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
                { name: 'Quick Links', route: 'quick_links', type: 'quick_link' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-telegram-logo',
            // iconName: '',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            iconClass: 'kt-menu__link-icon flaticon2-image-file',
            // iconName: '',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },


        {

            name: 'Compendium',
            type: 'compendium',
            // children: [
            //     { name: 'Compendiums', route: 'compendiums', type: 'compendium' },
            //     { name: 'Categories', route: 'compendium_categories', type: 'compendium_category' },
            // ],
            route: 'compendiums',
            iconClass: 'kt-menu__link-icon flaticon2-checking',
            // iconName: '',
            color: 'navy',
            group: 'village',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Calendar',
            type: 'event',
            route: 'events',
            // children: [
            //     { name: 'Events', route: 'events', type: 'event' },
            //     { name: 'Categories', route: 'event_categories', type: 'event_category' },
            // ],
            iconClass: 'kt-menu__link-icon flaticon-event-calendar-symbo',
            // iconName: '',
            color: 'navy',
            group: 'village',
            iconComponent: FeatherIcons.CalendarIcon,
        },

        // {
        //     name: 'Messages',
        //     route: 'messages',
        //     // iconName: '',
        //     color: 'navy',
        //     group: 'village',
        //     iconComponent: FeatherIcons.MessageSquareIcon,
        // },
        {
            name: 'Residents',
            type: 'resident',
            route: 'residents',
            iconClass: 'kt-menu__link-icon flaticon2-avatar',
            // iconName: '',
            color: 'navy',
            group: 'village',
            iconComponent: FeatherIcons.UserIcon,
        },
        {
            name: 'Gallery',
            type: 'gallery',
            route: 'galleries',
            iconClass: 'kt-menu__link-icon flaticon2-calendar-3',
            // iconName: '',
            color: 'navy',
            group: 'village',
            iconComponent: FeatherIcons.FilmIcon,
        },
        {
            name: 'Documents',
            // route: 'documents',
            children: [
                { name: 'Documents', route: 'documents', type: 'document', },
                { name: 'Categories', route: 'document_categories', type: 'document_category' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-calendar-3',
            // iconName: '',
            color: 'navy',
            group: 'village',
            iconComponent: FeatherIcons.FolderIcon,
        },
        {
            name: 'Staff',
            route: 'staff_members',
            iconClass: 'kt-menu__link-icon flaticon2-avatar',
            // iconName: '',
            color: 'navy',
            group: 'village',
            iconComponent: FeatherIcons.UsersIcon,
        },

        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-talk',
            // iconName: '',
            color: 'navy',
            group: 'communications',
            iconComponent: FeatherIcons.MailIcon,
        },
        {
            name: 'Notices',
            type: 'notice',
            route: 'notices',
            // children: [
            //     { name: 'Notices', route: 'notices', type: 'notice' },
            //     { name: 'Categories', route: 'notice_categories', type: 'notice_category' },
            // ],
            route: 'notices',
            iconClass: 'kt-menu__link-icon flaticon2-calendar-3',
            // iconName: '',
            color: 'navy',
            group: 'communications',
            iconComponent: FeatherIcons.BellIcon,
        },
        {
            name: 'Messages',
            route: 'campaigns',
            type: 'campaign',
            iconClass: 'kt-menu__link-icon flaticon2-telegram-logo',
            // iconName: '',
            color: 'navy',
            group: 'communications',
            iconComponent: FeatherIcons.MessageSquareIcon,
        },

        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-user',
            // iconName: '',
            color: 'navy',
            group: 'admin',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'kt-menu__link-icon flaticon2-settings',
            // iconName: '',
            color: 'navy',
            group: 'admin',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
